import Vue from "vue";
import Router from "vue-router";

import Start from "./views/Start";
import SaveTheDate from "./views/SaveTheDate";
import Party from "./views/Party";
import Directions from "./views/Directions";
import FAQ from "./views/FAQ";
import Recommendations from "./views/Recommendations";
import Ticket from "./views/Ticket";
import Privacy from "./views/Privacy";
import Contact from "./views/Contact";
import Impressum from "./views/Impressum";
import Newsletter from "./views/Newsletter";
import NewsletterConfirm from "./views/NewsletterConfirm";
import NewsletterCancel from "./views/NewsletterCancel";
import TicketChangeOfferConfirm from "./views/TicketChangeOfferConfirm";
import TicketChangeRequestConfirm from "./views/TicketChangeRequestConfirm";
import TicketOrderProxy from "./views/TicketOrderProxy";
import Authentication from "./views/Authentication";
import Screensaver from "./views/screensaver/Index";

// dev
import HotelSignup from "./views/hotel-signup/index";

import NewsletterAdministration from "./views/admin/Newsletter";
import TicketChangeAdministration from "./views/admin/TicketChange";
import TicketRequestAdministration from "./views/admin/TicketRequests";
import PageReloadAdministration from "./views/admin/Reloads";
import QuotasAdministration from "./views/admin/Quotas";

import FormVerification from "@/components/signup-form/form-submit/index";

import DidiLayout from "./layouts/Didi";
import PatriciaLayout from "./layouts/Patricia";

Vue.use(Router);

const ticketsAvailable = process.env.VUE_APP_TICKETS_AVAILABLE === "true";

let activatedViews = [
  {
    path: "/",
    redirect: "/start",
  },
  {
    path: "start",
    name: "start",
    component: Start,
  },
  {
    path: "save-the-date",
    name: "save-the-date",
    component: SaveTheDate,
  },
  {
    path: "party",
    name: "party",
    component: Party,
  },
  {
    path: "faq",
    name: "faq",
    component: FAQ,
  },
  {
    path: "ticket/confirm-offer",
    component: TicketChangeOfferConfirm,
  },
  {
    path: "ticket/confirm-request",
    component: TicketChangeRequestConfirm,
  },
  {
    path: "ticket/order/:ticketShopId",
    name: "ticket-order-proxy",
    props: true,
    component: TicketOrderProxy,
  },
  {
    path: "directions",
    name: "directions",
    component: Directions,
  },
  {
    path: "recommendations",
    name: "recommendations",
    component: Recommendations,
  },
  {
    path: "privacy",
    name: "privacy",
    component: Privacy,
  },
  {
    path: "impressum",
    name: "impressum",
    component: Impressum,
  },
  {
    path: "newsletter",
    name: "newsletter",
    redirect: "contact",
  },
  {
    path: "contact",
    alias: ["newsletter"],
    name: "contact",
    component: Contact,
  },
  {
    path: "newsletter-confirm",
    component: NewsletterConfirm,
  },
  {
    path: "newsletter-cancel",
    component: NewsletterCancel,
  },
  {
    path: "auth",
    component: Authentication,
  },
  {
    path: "newsletter/:id",
    name: "single-newsletter",
    component: Newsletter,
  },

  {
    path: "hotel",
    name: "hotel",
    component: HotelSignup,
  },
];

if (ticketsAvailable) {
  activatedViews.push({
    path: "ticket",
    name: "ticket",
    component: Ticket,
  });
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (window.innerWidth > 1000) {
      return;
    }

    return {
      selector: "#main-content-anchor",
    };
  },
  routes: [
    {
      path: "/",
      component: DidiLayout,
      children: activatedViews,
    },
    {
      path: "/screensaver",
      component: Screensaver,
    },
    // internal component routes
    {
      path: "/_form/form-transmit",
      component: FormVerification,
      props: (route) => ({
        formId: route.query.formId,
        transmissionPIN: route.query.pin,
        autoTransmit: true,
      }),
    },
    {
      path: "/admin",
      name: "admin",
      component: PatriciaLayout,
      children: [
        {
          path: "ticket-change",
          name: "ticketChangeAdmin",
          component: TicketChangeAdministration,
        },
        {
          path: "newsletter",
          name: "newsletterAdmin",
          component: NewsletterAdministration,
        },
        {
          path: "ticket-request",
          name: "ticketRequestAdmin",
          component: TicketRequestAdministration,
        },
        {
          path: "page-reloads",
          name: "pageReloadAdmin",
          component: PageReloadAdministration,
        },
        {
          path: "quotas",
          name: "quotasAdmin",
          component: QuotasAdministration,
        },
      ],
    },
  ],
});
